import React, { useRef, useState } from "react";
import styles from "./CareerWithAptech.module.scss";
import CareerWithAptechBanner from "../../assets/images/CareerWithAptechBannerImg.png";
import skillTrainingBanner from "../../assets/images/skillTrainingBanner.png";
import downloadArrow from "../../assets/images/downloadArrow.png";
import CareerCard from "../CustomComponent/CareerCard.tsx";
import location from "../../assets/images/location.png";
import ImageTextSection from "../CustomComponent/ImageTextSection.tsx";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import { motion } from "framer-motion";


interface CareerItem {
  title: string;
  subTitle: string;
}

const salesItems = [
  "Management of existing business partners in the assigned region for achieving budgeted nos. in (Booking/ Billing /Collection).",
  "Build Business partners’ trust by providing timely operational support & guidance for building business. ",
  "Drive & implement local Sales & marketing activities for revenue generation. ",
  "Tracking of Competitor's activities & re-design efforts if needed to counter this Channel management & development. ",
  "Franchisee management & revenue generation. ",
  "Acquisition and Activation of Franchisees: Prospecting, Profiling, Appointments, Meetings, Needs Analysis, Pitching, Closing, Processing and Documentation, Obtaining Referrals and Lead Generation. Infrastructure setup for Franchisees, Branding & Marketing Collaterals, Connectivity, IT & Software Setup, Franchisee Staff Training, Documentation and Compliance. ",
  "Supporting Enrolments for Franchisees: Supporting Franchisees in acquisitions of clients by accompanying them on meetings, providing training and knowledge support, assisting with any step of their acquisition process, as and when required. ",
  "Franchisee Quality & Compliance Parameters: Following operational processes, adhering to compliance requirements, documentation, certifications, etc. To ensure that Franchisee clients are getting services as per Aptech Standards. To initiate action in cases of delinquency/ non-compliance/ leakage etc. ",
];
const profilesItems = [
  "2-3 years of experience in franchisee sales. ",
  "Graduate/ MBA. ",
  "Excellent communication skills.  ",
  "Good presentation skills",
  "Team player.  ",
  "Self-motivated and result-driven, with excellent negotiation skills. ",
  "Passion for Sales.  ",
  "Regional local language knowledge (Mandatory).",
];

const salesItemsRegional = [
  "Formulate marketing strategies based on market conditions, demographics.",
  "Accompany team members in the field, meet clients and intervene as and when required. Assist Closures.",
  "Review Sales Reports, Leads Generated and Conversions etc. and discuss with team. Goal Setting and Action Planning.",
  "Servicing Franchise owners, driving BPs to increase enrolments, profitability, etc. ",
  "Plan, direct, and coordinate the activities of direct reportees. Ensure adherence to Systems, procedure, policies of the organization. ",
  "Following Operational processes, adhering to compliance requirements, documentation, certifications, etc. To ensure that students are getting services as per Aptech Standards. To initiate action in cases of delinquency / non-compliance / Leakage etc. ",
  "Conflict Resolution, Problem Solving.",
];
const profilesItemsRegional = [
  "5+ years of experience in Sales",
  "Graduate/ MBA.",
  "Excellent communicative abilities in English",
  "Good presentation skills",
  "Team player.",
  "Passion for Sales.",
];

const salesItemsZonal = [
  "Handling sales and support academics.",
  "Formulate marketing strategies based on market conditions, demographics, etc.",
  "Build and upgrade knowledge for self and team on: Product, Policy and Process.",
  "Accompany team members in the field, meet clients and intervene as and when required. Assist Closures.",
  "Review Sales Reports, Leads Generated and Conversions etc. and discuss with team.",
  "Goal Setting and Action Planning.",
  "To monitor BPs, Team, indirect reportees etc. on process adherence, target vs performance, Leakages, Logistics, Collections, Checklist adherence, etc.",
  "To develop budget projections based on trends, expansion plans, marketing and business development strategy, etc. To monitor the spend on budgets based on budgeted vs actual, and ensure compliance.",
  "To create annual Business Development plan, break it into cohesive sections based on goals, time, budgets, resources, etc. To assign realistic, relevant and challenging targets when projecting for the year.",
];
const profilesItemsZonal = [
  "10+ years of experience in Sales.",
  "Excellent communicative abilities in English.",
  "Good presentation skills.",
  "Passionate towards sales.",
  "Active listening and responsiveness.",
  "Qualification: Graduate/ Management Graduate.",
  "Coaching & mentoring.",
  "Result driven.",
  "Self-motivated",
];

const salesItemsCentres = [
  "The candidate will be required to look into daily administration, operation, student-parent handling, admin staff handling, support staff management, vendor alliance management, support and manage in-centre and out-centre marketing activities, and crisis handling.",
  "Handling a team of counselors, faculties etc.",
  "Marketing strategies along with the regular revision of the same.",
  "Interviewing and recruiting the staffs.",
  "Managing the batch schedule, coordinating with the faculties.",
  "Maintaining good interpersonal relations with schools & universities.",
  "Ensure compliance of company policies, MIS reporting & collection.",
  "Responsible for sale & services. Look after product launch & promotional activities, media planning & buying, designing & implementing.",
  "Ensuring high quality delivery.",
];
const profilesItemsCentres = [
  "3+ years of experience in the same field",
  "Excellent English communication skills",
  "Good presentation skills",
  "Self-motivated and result-driven, with excellent negotiation skills",
  "Graduate/ MBA",
  "Team player",
];
const jodDescriptionCounselor = [
  "Handling walk in enquiries, telephonic enquiries and email enquiries & convert them to enrolments.",
  "Responsibility for monthly, quarterly and annual student enrolment budgets.",
  "Ensuring adequate batch size and meeting batch start deadlines.",
];
const jodDescriptionDataAnalyst = [
  "Member will be responsible for Collecting, Analyzing, interpreting data for business insights, decision making.",
  "To work collaboratively with Cross-functional teams to identify areas of business growth, optimization of resources and concern. ",
  "To identify trends, patterns, and correlation. ",
  "Attention to details, visualization of data for easy understanding.",
  "Analyze existing KPIs, define new business metrics for performance analysis. ",
  "Forecasting and Predictive analysis. ",
  "Implement data models to build different scenarios and strategies. ",
  "To learn new technologies, data analysis tools and advise organization on adopting new tools and techniques.",
  "Ability to work independently and with other teams."


];
const jodDescriptionGenAi = [
  "Develop solutions on Generative AI using Python, LangChain, and HuggingFace.",
  "Perform prompt engineering and work with Large Language Models (LLMs).",
  "Utilize and fine-tune pre-trained models from HuggingFace.",
  "Collaborate with the Business to deliver AI solutions.",
  


];
const candidateProfileCouncelor = [
  "Must have good communication skills.",
  "Should be pleasing personality.",
  "Proficiency in MS office (MS Word, MS Excel, Outlook).",
];
const candidateProfileDataAnalyst = [
  "Familiarity with data visualization tools and techniques. ",
  "Work Experience - 4+ years of experience in Data Analysis ",
  "Proficiency in MS Excel, SQL, Python. ",
  "Proficiency in Tableau. ",
  "Excellent communicative.",
  "Good presentation skills. ",
  "Attention to details. ",
  "Team player. ",
  "Result driven.",
  "Self-motivated."



];

const candidateProfileGenAI = [
  "Strong desire to learn and improve skills.",
  "Proficiency in prompt engineering.",
  "Advanced programming skills in Python.",
  "Understanding of basic ML engineering processes and metrics.",
  "Familiarity with AI frameworks such as LangChain, Cohere and HuggingFace. ",
  "Experience with Keras, TensorFlow, and PyTorch.",
  "Total work experience of 3-5 years, with at least 1 year in AI/ML",
  "Knowledge of data structures, linear algebra, probability, and statistics. ",
  "Bachelor's degree or equivalent experience in Computer Science or AI. ",
  "Deep understanding of system architecture and frameworks like FastAPI and Unicorn.",
  "Proficiency in at least one deep learning architecture: Transformers, Seq2Seq Models, GANs, or Diffusion Models."



];

const jodDescriptionFrontend = [
  "Execute on Software Engineering best practices for developing, unit testing, and deploying code.",
  "Analyse & create requirements basis the discussions and understanding from various stakeholders.",
  "Create clear technical specifications.",
  "Analyze and create efficient deployment architecture.",
  "Deploying code to production, tracking and debugging technical issues in production environment.",
  "Define code architecture decisions to support a high-performance and scalable product with a minimal footprint.",
  "Design and create advanced, elegant and efficient systems.",
  "Writing and conducting unit test cases, system integration test cases and load test for the application features/APIs developed.",
  "Work with your team to design and build software applications to function across multiple platforms.",
  "Maintain and improve the website by developing new user-facing and mobile-based features.",
  "Build reusable code and libraries for future use.",
  "Validate the technical feasibility of UI/UX designs.",
  "Optimize application for maximum speed and scalability.",
  "Assure that all user input is validated before submitting to the back-end.",
  "Conduct thorough testing of user interfaces in multiple platforms to ensure all designs render correctly and systems function properly",
  "Get feedback from and build solutions for users and customers",
  "Write functional requirement documents and guides.",
  "Ensure high-quality graphic standards and brand consistency.",
  "Collaborate with other team members and stakeholders",
];
const candidateProfileFrontend = [
  "Bachelor’s degree or equivalent in Computer Science or Information Technology.",
  "1-3 years software development experience.",
  "In-depth understanding of the entire web development process (design, development, and deployment).",
  "Good understanding of SEO principles.",
  "A thorough understanding of computer architecture, operating systems and data structures.",
  "Strong understanding of front-end coding and development technologies.",
  "Extensive experience in Reactjs, CSS, Javascript and Nodejs/ Nextjs/ Angular.",
  "Basic understanding of server-side CSS pre-processing platforms, such as LESS and SASS.",
  "Good knowledge of MongoDB and relational databases.",
  "Should have working knowledge of CI/CD pipelines, docker, Kubernetes.",
  "Good to have Cloud services knowledge related to AWS/Azure.",
  "Proficient understanding of cross-browser compatibility issues and ways to work around them.",
];

const jodDescriptionPlacement = [
  "Organizing placements & support students in the process.",
  "Prospecting and associating with new clients.",
  "Meeting clients & creating opportunities as per student profile.",
  "Understanding the manpower requirement of the respective client and mapping the current student population’s profile with the requirement.",
  "Creating student database with regards to the profile.",
  "Creating MIS of students placed vis-à-vis the organization and the position for which the students were placed.",
  "Ensuring that the defined targets are achieved.",
];
const candidateProfilePlacement = [
  "3+ years of experience in Placement or Coordination.",
  "Media & Entertainment industry experience preferred.",
  "Excellent communication & interpersonal skills.",
  "Good presentation skills.",
  "Good negotiation skills.",
  "Any graduate (preferable).",
];
const jodDescription3DFaculty = [
  "Conduct training at the centre for software like Autodesk Maya, Autodesk 3ds Max, ZBrush, Unity, Adobe Photoshop CC, Adobe After Effects CC, Adobe Premiere Pro CC, Adobe Audition CC, MS Excel & MS PowerPoint.",
  "Conduct workshops and seminars in colleges.",
  "Ensuring timely delivery of modules.",
];
const candidateProfile3DFaculty = [
  "3 years of good teaching experience in Autodesk Maya, Autodesk 3ds Max, ZBrush, Unity, Adobe Photoshop CC, Adobe After Effects CC, Adobe Premiere Pro CC, Adobe Audition CC, MS Excel & MS PowerPoint.",
  "Good presentation skills.",
  "Self-motivated, process oriented, and result oriented.",
  "Good time management skills.",
];

// const jodDescriptionEnterPrise = [
//   "Drive sales efforts to meet and exceed targets through engagement with educational institutions, government clients and corporate clients.",
//   "Identify and develop new leads across the education and corporate sectors using market insights.",
//   "Analyze client needs and provide tailored, solution-oriented offerings to meet their strategic objectives.",
//   "Monitor policy developments and trends to identify and assess new business opportunities.",
//   "Build and maintain long-term client relationships while ensuring high levels of customer satisfaction.",
//   "Lead negotiations and client acquisition.",
//   "Stay updated on market trends and competitors to adjust and enhance sales strategies.",
//   "Work closely with internal teams to ensure smooth execution and client satisfaction.",
//   "Prepare and present regular sales reports and revenue forecasts to senior management.",
// ];
// const candidateProfileEnterPrise = [
//   "7-10 years of experience in enterprise sales.",
//   "Graduate/ MBA.",
//   "Excellent communication skills.",
//   "Strong ability to build, maintain and deepen client partnerships.",
//   "Skilled in Negotiations.",
//   "Data-Driven Decision Making",
// ];

// const jodDescriptionDotNet = [
//   "Develop and maintain efficient, reusable, and reliable .NET Core applications.",
//   "Implement data access layers using Entity Framework Core (EF Core), including database migrations, complex queries, and performance optimization.",
//   "Collaborate with front-end developers, business analysts, and other stakeholders to design and deliver end-to-end solution.",
//   "Ensure the performance, quality, and responsiveness of applications through unit testing and code reviews.",
//   "Troubleshoot and resolve issues in existing applications, ensuring system reliability and performance.",
//   "Optimize application performance by writing efficient queries and ensuring proper use of EF Core features such as lazy loading, eager loading, and explicit loading.",
//   "Write and maintain technical documentation for the codebase and system architecture.",
// ];
// const candidateProfileDotNet = [
//   "2-5 years of experience in .Net.",
//   "Proficiency in C# and the .NET Core framework.",
//   "Strong experience with Entity Framework Core (EF Core), including database migrations, LINQ queries, and data modeling.",
//   "Solid understanding of SQL Server and database design principles.",
//   "Knowledge of architectural patterns like MVC, Repository Pattern, and Dependency Injection.",
//   "Experience with building and consuming RESTful APIs.",
//   "Familiarity with version control systems like Git.",
//   "Experience in unit testing frameworks (e.g., xUnit, NUnit) and mocking frameworks.",
//   "Ability to optimize database performance by writing efficient queries and handling large data sets",
// ];

// const jodDescriptionNetwork = [
//   "Configuration of servers, operating systems administration, hardening, load balancers, firewall including but not limited to management of users, processes, resource contention, preventive maintenance and management of updates & patches to ensure that the system is properly updated.",
//   "Periodic health check of the systems, troubleshooting problems, analyzing and implementing rectification measures.",
//   "Management of the usernames, roles and passwords of all the relevant subsystems, including, but not limited to servers, applications, devices, etc.",
//   "Knowledge of system security and data backup/recovery.",
//   "Install and upgrade computer components and software, manage virtual servers, and integrate automation processes.",
//   "Manage network servers and technology tools, Set up accounts and workstations.",
// ];
// const candidateProfileNetwork = [
//   "2-5 years of experience in .Net.",
//   "Proficiency in C# and the .NET Core framework.",
//   "Strong experience with Entity Framework Core (EF Core), including database migrations, LINQ queries, and data modeling.",
//   "Solid understanding of SQL Server and database design principles.",
//   "Knowledge of architectural patterns like MVC, Repository Pattern, and Dependency Injection.",
//   "Experience with building and consuming RESTful APIs.",
//   "Familiarity with version control systems like Git.",
//   "Experience in unit testing frameworks (e.g., xUnit, NUnit) and mocking frameworks.",
//   "Ability to optimize database performance by writing efficient queries and handling large data sets",
// ];

// const jodDescriptionPlacementManager = [
//   "Organizing placements & support students in the process.",
//   "Prospecting and associating with new clients.",
//   "Meeting clients & creating opportunities as per student profile.",
//   "Understanding the manpower requirement of the respective client and mapping the current student population’s profile with the requirement.",
//   "Creating student database with regards to the profile.",
//   "Creating MIS of students placed vis-à-vis the organization and the position for which the students were placed.",
//   "Ensuring that the defined targets are achieved.",
// ];
// const candidateProfilePlacementManager = [
//   "7-10 years of experience in Placement management.",
//   "Media & Entertainment industry experience preferred.",
//   "Excellent communication & interpersonal skills.",
//   "Good presentation skills.",
//   "Good negotiation skills.",
//   "Any graduate (preferable)",
// ];

const userReaserchList =[
  "Conduct user research through interviews, surveys, and usability testing to understand user needs and behaviours. ",
  "Analyze research data to develop user personas, user journeys, and detailed user requirements. ",
  "UI/UX Design.",
  "Create wireframes, storyboards, user flows, process flows, and site maps to effectively communicate interaction and design ideas.",
  "Design high-fidelity mock-ups and prototypes that illustrate the look and feel of the product. ",
  "Ensure designs are responsive and work seamlessly across different devices and platforms. "

]
const collaborationList =[
  "Work closely with product managers, developers, and other stakeholders to ensure designs are feasible and aligned with business goals. ",
  "Participate in brainstorming sessions and design reviews, providing constructive feedback and incorporating feedback into designs. ",
  "Design Systems and Standards",
  "Develop and maintain design systems, style guides, and UI components to ensure consistency across all digital products. ",
  "Stay up to date with the latest design trends, tools, and technologies, and incorporate them into the design process where appropriate. "

]
const testingList =[
  "Create interactive prototypes for usability testing and stakeholder presentations. ",
  "Conduct usability tests and gather feedback to iterate and improve designs. ",
  "Implementation and Support.",
  "Work with developers to ensure designs are implemented accurately and provide guidance during the development process. ",
  "Review final product output to ensure it meets design specifications and quality standards."


]

const candidateProfileProductDesigner =[
  "Preferably from Design School – NID/NIFT or with some design qualification.",
  "Creative individual with 5 years of hands-on experience in various aspects of designs at an online consumer internet organisation. ",
  "Proven track record of shipping multiple high quality and thoughtful product features in a fast-paced dynamic environment. ",
  "A solid understanding of design nuances across ecosystems - Android, iOS, Mobile Web and Desktops. ",
  "Should have delivered positive impact on metrics using design changes driven by insights from user research and market studies. ",
  "Excellent analytical and problem-solving skills to understand complex user/business problems and translate these into elegant designs. ",
  "Open to feedback and at the same time should be able to push back on subjective feedback with a clear point of view whenever appropriate. ",
  "Should be up to date with the latest design trends."

]

const jodDescriptionBusinessDevelopment =[
  "Responsible for the business development & operations activities of the assigned countries to ensure set targets are achieved and business grows remarkably. ",
  "Network within communities to find and attract new business. ",
  "Review Sales Reports, leads generated, conversions etc. ",
  "Servicing BP, driving them to increase enrolments, profitability, etc. ",
  "Prospecting, Profiling, Appointments, Meetings, Needs Analysis, Pitching, Closing, Processing and Documentation, obtaining referrals and lead generation. ",
  "Infrastructure setup for BPs, Branding & Marketing Collaterals, Connectivity, IT & Software Setup, BP Staff Training, Documentation and Compliance. ",
  "Supporting BPs in increasing student enrolments by conducting seminars at colleges and providing training and knowledge support to the counsellors. ",
  "Regular interaction with BPs, meeting students when required, resolving BP complaints, handling exceptions tactfully."




]

const candidateBusinessDevelopment =[
  "Excellent communicative abilities in English. ",
  "Good presentation skills. ",
  "Team Player. ",
  "Passionate towards sales. ",
  "Proficiency in MS Office. ",
"Self-motivated. ",
"Result driven. ",
"Excellent negotiation skills."






]
const jodDescriptionMarketingTeam =[
  "Manage and coordinate all marketing, advertising and promotional activities through design agency. ",
  "Establish effective working relationships with stakeholders to ensure products and campaigns are implemented for Marketing demand generation programs/activities. ",
  "Digital First approach to drive brand and engagement related activities across stakeholders. ",
  "Conduct market research to determine market requirements for existing and future products and campaigns.",
  "Develop and implement marketing plans and projects for new and existing products.",
  "Expand and develop marketing platforms to engage students. ",
  "Manage the productivity of the marketing plans and projects. ",
  "Analyze market trends of customer research, current market conditions and competitor information and analyze customer insight. ",
  "Monitor, review and report on all marketing activity and results and recommend feedback based on analysis. ",
  "Determine and manage the marketing budget and prepare spend analysis. ",
  "Prepare marketing strategies alongside stakeholders and create effective marketing presentations. ",
  "Liaise with media and advertising agency. "


]

const candidateProfileMarketingTeam =[
  "Excellent communicative abilities in English. ",
  "Good presentation skills. ",
  "3+ years of experience in client servicing.",
  "Excellent in brand marketing. "


]

const careerItems: CareerItem[] = [
  {
    title: "Area Sales Head",
    subTitle: "Pune, Bengaluru, Mumbai, Noida, Hyderabad, Chennai, & Kolkata",
  },
  {
    title: "Regional Sales Head",
    subTitle: "Noida Hyderabad, Bengaluru & Mumbai",
  },
  {
    title: "Zonal Sales Head",
    subTitle: "Mumbai & Noida",
  },
  {
    title: "Centre Manager",
    subTitle: "Bengaluru-Koramangala",
  },
  {
    title: "Counselor",
    subTitle: "Andheri & Bengaluru",
  },
  {
    title: "Data Analyst",
    subTitle: "Mumbai",
  },
  {
    title: "Business Development International",
    subTitle: "Mumbai-Andheri",
  },
  {
    title: "Front End Developer",
    subTitle: "Mumbai",
  },
  {
    title: "GenAI Engineer",
    subTitle: "Mumbai",
  },
  // {
  //   title: "",
  //   subTitle: "Bengaluru-Koramangala",
  // },
  {
    title: "Regional Placement Executive",
    subTitle: "Noida, Mumbai, Bengaluru & Kolkata",
  },
  {
    title: "Product Designer",
    subTitle: "Mumbai",
  },
  {
    title: "Marketing Team Member",
    subTitle: "Mumbai-Andheri",
  },
  // {
  //   title: "Product Designer",
  //   subTitle: "Mumbai",
  // },
  // {
  //   title: "Business Development – International",
  //   subTitle: "Bengaluru-Koramangala",
  // },
  // {
  //   title: "Marketing Team Member",
  //   subTitle: "Bengaluru-Koramangala",
  // },
  {
    title: "3D Faculty",
    subTitle: "Bengaluru, Mumbai",
  },
  // {
  //   title: "Business Development Lead - Enterprise Business Group",
  //   subTitle: "Noida",
  // },
  // {
  //   title: "Dot Net Developer",
  //   subTitle: "Mumbai",
  // },
  // {
  //   title: "Network & Server Administrator",
  //   subTitle: "Mumbai",
  // },
  // {
  //   title: "Placement Manager",
  //   subTitle: "Noida",
  // },
];

const CareerWithAptech: React.FC = () => {
  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "Careers with Aptech", link: "" },
  ];

  return (
    <div id="CareerWithAptech" className={styles.CareerWithAptech}>
      <BreadCrumb menu={breadcrumb} />

      <div className="container">
      <motion.div
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.2 }} // Triggers animation when 50% of the element is visible
  transition={{ duration: 1, ease: "easeInOut" }}
  >
        <Banner />
        <BannerTwo />
        </motion.div>
        <motion.div
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.2 }} // Triggers animation when 50% of the element is visible
  transition={{ duration: 1, ease: "easeInOut" }}
  >
        <VacanciesSection />
        </motion.div>
      </div>
    </div>
  );
};

const Banner = () => {
  const content = [
    `Education is a dynamic industry focused on empowering individuals through knowledge delivery and skill development. Aptech is proud to be at the forefront of this sector in the 21st century viz. disseminating learning, skill development, and helping build the knowledge economy. `,
    `Working at Aptech is an enriching and enjoyable experience. Here,
            challenges are balanced by rewards, achievements, and employee
            satisfaction. `,
  ];
  return (
    <div className="section">
      <div className="row mt-5">
        <div className="col-12">
          <ImageTextSection
            imageSrc={CareerWithAptechBanner}
            imageAlt="CareerWithAptechImage"
            content={content}
            heading="Careers with Aptech"
            reverse={true}
            imageHeight={`25rem`}
            imageHeightTablet={`25rem`}
          />
        </div>
      </div>
    </div>
  );
};
const BannerTwo = () => {
  const contentTraining = [
    ` Aptech has been in the vocational skill-training business in India
            for more than three decades now. It is a process-driven organization
            that values customer service orientation among its people. Awards
            and recognition are given to employees who demonstrate exceptional
            performance.`,
    `Aptech typically recruits for positions such as sales, marketing and business development, faculty, academic support, career counselling, corporate training, content development/ E-learning as well as for finance, HR, IT, etc. for offices in India and abroad. `,
  ];
  return (
    <div className="section">
       
      <div className="row">
        <div className="col-12">
          <ImageTextSection
            imageSrc={skillTrainingBanner}
            imageAlt="skillTrainingBannerImage"
            content={contentTraining}
            heading="Vocational skill-training business in India"
            isMobileReverse={true}
            imageAlign="center"
            imageHeightTablet={`25rem`}
            imageHeight={`25rem`}
          />
        </div>
      </div>
    </div>
  );
};
const VacanciesSection = () => {
  const modalRef = useRef<HTMLDivElement | null>(null);
  const [title, setTitle] = useState<string>("");

  const handleShowModal = (clickedTitle: string) => {
    setTitle(clickedTitle);

    if (modalRef.current) {
      // Hide any existing modal instance
      const bootstrap = require("bootstrap");
      const modalInstance = bootstrap.Modal.getInstance(modalRef.current);
      if (modalInstance) {
        modalInstance.hide();
      }

      // Show the updated modal
      const modal = new bootstrap.Modal(modalRef.current);
      modal.show();
    }
  };

  return (
    <div className="">
     
      <div className="row">
        <div className="col-12">
          {/* <p className="heading">Careers with Aptech</p> */}
          {/* <p className="para">
            Aptech is always looking for talented people with diverse skill sets
            to expand its growing family.
          </p>
          <p className="para">
            Wish to make a career with Aptech? Check out the{" "}
            <strong> Current Vacancies </strong>
            here.
          </p> */}
        </div>
      </div>
      <div className="mb-3">
        {/* <div className="row">
          {careerItems.map((item, index) => (
            <div className="col-lg-3 col-md-6 col-sm-12 mt-3" key={index}>
              <CareerCard
                downloadArrow={downloadArrow}
                title={item.title}
                subTitle={item.subTitle}
                handleShowModal={handleShowModal}
              />
            </div>
          ))}
        </div> */}

        <div
          className="modal fade"
          id="careerModal"
          ref={modalRef}
          tabIndex={-1}
          aria-labelledby="careerModalLabel"
          aria-hidden="true"
        >
          <div className={`modal-dialog modal-xl modal-dialog-scrollable`}>
            <div className={`modal-content ${styles.modalContent}`}>
              <div className="modal-header w-100 d-flex justify-content-between">
                <p className="heading mb-0 ">{title}</p>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row g-0">
                  {title === "Area Sales Head" && (
                    <>
                      <div className="col-12 d-flex justify-content-start mb-3">
                        <div className="d-flex align-items-center">
                          <img
                            src={location}
                            alt="location"
                            width="40"
                            height="40"
                            className="img-fluid"
                          />
                          <p className="para mb-3 mt-3 p-1">
                            Location: Pune, Bengaluru, Mumbai, Noida, Hyderabad,
                            Chennai & Kolkata
                          </p>
                        </div>
                      </div>
                      <div className="row g-0">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Brief Job Description:
                          </p>
                          <ul className={styles.listMainDiv}>
                            {salesItems.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Desired Candidate Profile:
                          </p>
                          <ul>
                            {profilesItems.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <a
                          href="mailto:careers@aptech.co.in"
                          className={styles.link}
                        >
                          <div className={styles.buttonDiv}>
                            <p className="secondary-btn">
                              Apply for this position
                            </p>
                          </div>
                        </a>
                      </div>
                    </>
                  )}
                  {title === "Regional Sales Head" && (
                    <>
                      <div className="col-12 d-flex justify-content-start mb-3">
                        <div className="d-flex align-items-center">
                          <img
                            src={location}
                            alt="location"
                            width="40"
                            height="40"
                            className="img-fluid"
                          />
                          <p className="para mb-3 mt-3 p-1">
                            Location: Noida, Hyderabad, Bengaluru & Mumbai
                          </p>
                        </div>
                      </div>
                      <div className="row g-0">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Brief Job Description:
                          </p>
                          <ul className={styles.listMainDiv}>
                            {salesItemsRegional.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Desired Candidate Profile:
                          </p>
                          <ul>
                            {profilesItemsRegional.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <a
                          href="mailto:careers@aptech.co.in"
                          className={styles.link}
                        >
                          <div className={styles.buttonDiv}>
                            <p className="secondary-btn">
                              Apply for this position
                            </p>
                          </div>
                        </a>
                      </div>
                    </>
                  )}
                  {title === "Zonal Sales Head" && (
                    <>
                      <div className="col-12 d-flex justify-content-start mb-3">
                        <div className="d-flex align-items-center">
                          <img
                            src={location}
                            alt="location"
                            width="40"
                            height="40"
                            className="img-fluid"
                          />
                          <p className="para mb-3 mt-3 p-1">Mumbai & Noida</p>
                        </div>
                      </div>
                      <div className="row g-0">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Brief Job Description:
                          </p>
                          <ul className={styles.listMainDiv}>
                            {salesItemsZonal.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Desired Candidate Profile:
                          </p>
                          <ul>
                            {profilesItemsZonal.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>

                        <a
                          href="mailto:careers@aptech.co.in"
                          className={styles.link}
                        >
                          <div className={styles.buttonDiv}>
                            <p className="secondary-btn">
                              Apply for this position
                            </p>
                          </div>
                        </a>
                      </div>
                    </>
                  )}
                  {title === "Centre Manager" && (
                    <>
                      <div className="col-12 d-flex justify-content-start mb-3">
                        <div className="d-flex align-items-center">
                          <img
                            src={location}
                            alt="location"
                            width="40"
                            height="40"
                            className="img-fluid"
                          />
                          <p className="para mb-3 mt-3 p-1">
                            Bengaluru-Koramangala
                          </p>
                        </div>
                      </div>
                      <div className="row g-0">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Brief Job Description:
                          </p>
                          <ul className={styles.listMainDiv}>
                            {salesItemsCentres.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Desired Candidate Profile:
                          </p>
                          <ul>
                            {profilesItemsCentres.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <a
                          href="mailto:careers@aptech.co.in"
                          className={styles.link}
                        >
                          <div className={styles.buttonDiv}>
                            <p className="secondary-btn">
                              Apply for this position
                            </p>
                          </div>
                        </a>
                      </div>
                    </>
                  )}
                  {title === "Front End Developer" && (
                    <>
                      <div className="col-12 d-flex justify-content-start mb-3">
                        <div className="d-flex align-items-center">
                          <img
                            src={location}
                            alt="location"
                            width="40"
                            height="40"
                            className="img-fluid"
                          />
                          <p className="para mb-3 mt-3 p-1">Mumbai </p>
                        </div>
                      </div>
                      <div className="row g-0">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Brief Job Description:
                          </p>
                          <ul className={styles.listMainDiv}>
                            {jodDescriptionFrontend.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Desired Candidate Profile:
                          </p>
                          <ul>
                            {candidateProfileFrontend.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <a
                          href="mailto:careers@aptech.co.in"
                          className={styles.link}
                        >
                          <div className={styles.buttonDiv}>
                            <p className="secondary-btn">
                              Apply for this position
                            </p>
                          </div>
                        </a>
                      </div>
                    </>
                  )}
                  {title === "Counselor" && (
                    <>
                      <div className="col-12 d-flex justify-content-start mb-3">
                        <div className="d-flex align-items-center">
                          <img
                            src={location}
                            alt="location"
                            width="40"
                            height="40"
                            className="img-fluid"
                          />
                          <p className="para mb-3 mt-3 p-1">
                            Andheri & Bengaluru{" "}
                          </p>
                        </div>
                      </div>
                      <div className="row g-0">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Brief Job Description:
                          </p>
                          <ul className={styles.listMainDiv}>
                            {jodDescriptionCounselor.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Desired Candidate Profile:
                          </p>
                          <ul>
                            {candidateProfileCouncelor.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <a
                          href="mailto:careers@aptech.co.in"
                          className={styles.link}
                        >
                          <div className={styles.buttonDiv}>
                            <p className="secondary-btn">
                              Apply for this position
                            </p>
                          </div>
                        </a>
                      </div>
                    </>
                  )}
                   {title === "Data Analyst" && (
                    <>
                      <div className="col-12 d-flex justify-content-start mb-3">
                        <div className="d-flex align-items-center">
                          <img
                            src={location}
                            alt="location"
                            width="40"
                            height="40"
                            className="img-fluid"
                          />
                          <p className="para mb-3 mt-3 p-1">
                          Mumbai{" "}
                          </p>
                        </div>
                      </div>
                      <div className="row g-0">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Brief Job Description:
                          </p>
                          <ul className={styles.listMainDiv}>
                            {jodDescriptionDataAnalyst.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Desired Candidate Profile:
                          </p>
                          <ul>
                            {candidateProfileDataAnalyst.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <a
                          href="mailto:careers@aptech.co.in"
                          className={styles.link}
                        >
                          <div className={styles.buttonDiv}>
                            <p className="secondary-btn">
                              Apply for this position
                            </p>
                          </div>
                        </a>
                      </div>
                    </>
                  )}
                    {title === "Product Designer" && (
                    <>
                      <div className="col-12 d-flex justify-content-start mb-3">
                        <div className="d-flex align-items-center">
                          <img
                            src={location}
                            alt="location"
                            width="40"
                            height="40"
                            className="img-fluid"
                          />
                          <p className="para mb-3 mt-3 p-1">
                          Mumbai{" "}
                          </p>
                        </div>
                      </div>
                      <div className="row g-0">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Brief Job Description:
                          </p>
                          <ul className={styles.listMainDiv}>
                            <p className="heading3">User Research and Analysis</p>
                            {userReaserchList.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                          <ul className={styles.listMainDiv}>
                            <p className="heading3">Collaboration</p>
                            {collaborationList.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                          <ul className={styles.listMainDiv}>
                            <p className="heading3">Prototyping and Testing</p>
                            {testingList.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Desired Candidate Profile:
                          </p>
                          <ul>
                            {candidateProfileProductDesigner.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <a
                          href="mailto:careers@aptech.co.in"
                          className={styles.link}
                        >
                          <div className={styles.buttonDiv}>
                            <p className="secondary-btn">
                              Apply for this position
                            </p>
                          </div>
                        </a>
                      </div>
                    </>
                  )}
                    {title === "GenAI Engineer" && (
                    <>
                      <div className="col-12 d-flex justify-content-start mb-3">
                        <div className="d-flex align-items-center">
                          <img
                            src={location}
                            alt="location"
                            width="40"
                            height="40"
                            className="img-fluid"
                          />
                          <p className="para mb-3 mt-3 p-1">
                          Mumbai{" "}
                          </p>
                        </div>
                      </div>
                      <div className="row g-0">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Brief Job Description:
                          </p>
                          <ul className={styles.listMainDiv}>
                            {jodDescriptionGenAi.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Desired Candidate Profile:
                          </p>
                          <ul>
                            {candidateProfileGenAI.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <a
                          href="mailto:careers@aptech.co.in"
                          className={styles.link}
                        >
                          <div className={styles.buttonDiv}>
                            <p className="secondary-btn">
                              Apply for this position
                            </p>
                          </div>
                        </a>
                      </div>
                    </>
                  )}
                   {title === "Marketing Team Member" && (
                    <>
                      <div className="col-12 d-flex justify-content-start mb-3">
                        <div className="d-flex align-items-center">
                          <img
                            src={location}
                            alt="location"
                            width="40"
                            height="40"
                            className="img-fluid"
                          />
                          <p className="para mb-3 mt-3 p-1">
                          Mumbai-Andheri {" "}
                          </p>
                        </div>
                      </div>
                      <div className="row g-0">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Brief Job Description:
                          </p>
                          <ul className={styles.listMainDiv}>
                            {jodDescriptionMarketingTeam.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Desired Candidate Profile:
                          </p>
                          <ul>
                            {candidateProfileMarketingTeam.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <a
                          href="mailto:careers@aptech.co.in"
                          className={styles.link}
                        >
                          <div className={styles.buttonDiv}>
                            <p className="secondary-btn">
                              Apply for this position
                            </p>
                          </div>
                        </a>
                      </div>
                    </>
                  )}
                                      {title === "Business Development International" && (
                    <>
                      <div className="col-12 d-flex justify-content-start mb-3">
                        <div className="d-flex align-items-center">
                          <img
                            src={location}
                            alt="location"
                            width="40"
                            height="40"
                            className="img-fluid"
                          />
                          <p className="para mb-3 mt-3 p-1">
                          Mumbai-Andheri{" "}
                          </p>
                        </div>
                      </div>
                      <div className="row g-0">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Brief Job Description:
                          </p>
                          <ul className={styles.listMainDiv}>
                            {jodDescriptionBusinessDevelopment.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Desired Candidate Profile:
                          </p>
                          <ul>
                            {candidateBusinessDevelopment.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <a
                          href="mailto:careers@aptech.co.in"
                          className={styles.link}
                        >
                          <div className={styles.buttonDiv}>
                            <p className="secondary-btn">
                              Apply for this position
                            </p>
                          </div>
                        </a>
                      </div>
                    </>
                  )}
                  {title === "Regional Placement Executive" && (
                    <>
                      <div className="col-12 d-flex justify-content-start mb-3">
                        <div className="d-flex align-items-center">
                          <img
                            src={location}
                            alt="location"
                            width="40"
                            height="40"
                            className="img-fluid"
                          />
                          <p className="para mb-3 mt-3 p-1">
                            Noida, Mumbai, Bengaluru & Kolkata
                          </p>
                        </div>
                      </div>
                      <div className="row g-0">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Brief Job Description:
                          </p>
                          <ul className={styles.listMainDiv}>
                            {jodDescriptionPlacement.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Desired Candidate Profile:
                          </p>
                          <ul>
                            {candidateProfilePlacement.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <a
                          href="mailto:careers@aptech.co.in"
                          className={styles.link}
                        >
                          <div className={styles.buttonDiv}>
                            <p className="secondary-btn">
                              Apply for this position
                            </p>
                          </div>
                        </a>
                      </div>
                    </>
                  )}
                  {title === "3D Faculty" && (
                    <>
                      <div className="col-12 d-flex justify-content-start mb-3">
                        <div className="d-flex align-items-center">
                          <img
                            src={location}
                            alt="location"
                            width="40"
                            height="40"
                            className="img-fluid"
                          />
                          <p className="para mb-3 mt-3 p-1">
                            Bengaluru, Mumbai
                          </p>
                        </div>
                      </div>
                      <div className="row g-0">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Brief Job Description:
                          </p>
                          <ul className={styles.listMainDiv}>
                            {jodDescription3DFaculty.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Desired Candidate Profile:
                          </p>
                          <ul>
                            {candidateProfile3DFaculty.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <a
                          href="mailto:careers@aptech.co.in"
                          className={styles.link}
                        >
                          <div className={styles.buttonDiv}>
                            <p className="secondary-btn">
                              Apply for this position
                            </p>
                          </div>
                        </a>
                      </div>
                    </>
                  )}
                  {/* {title ===
                    "Business Development Lead - Enterprise Business Group" && (
                    <>
                      <div className="col-12 d-flex justify-content-start mb-3">
                        <div className="d-flex align-items-center">
                          <img
                            src={location}
                            alt="location"
                            width="40"
                            height="40"
                            className="img-fluid"
                          />
                          <p className="para mb-3 mt-3 p-1">Noida </p>
                        </div>
                      </div>
                      <div className="row g-0">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Brief Job Description:
                          </p>
                          <ul className={styles.listMainDiv}>
                            {jodDescriptionEnterPrise.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Desired Candidate Profile:
                          </p>
                          <ul>
                            {candidateProfileEnterPrise.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <a
                          href="mailto:careers@aptech.co.in"
                          className={styles.link}
                        >
                          <div className={styles.buttonDiv}>
                            <p className="secondary-btn">
                              Apply for this position
                            </p>
                          </div>
                        </a>
                      </div>
                    </>
                  )} */}
                  {/* {title === "Dot Net Developer" && (
                    <>
                      <div className="col-12 d-flex justify-content-start mb-3">
                        <div className="d-flex align-items-center">
                          <img
                            src={location}
                            alt="location"
                            width="40"
                            height="40"
                            className="img-fluid"
                          />
                          <p className="para mb-3 mt-3 p-1">Mumbai </p>
                        </div>
                      </div>
                      <div className="row g-0">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Brief Job Description:
                          </p>
                          <ul className={styles.listMainDiv}>
                            {jodDescriptionDotNet.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Desired Candidate Profile:
                          </p>
                          <ul>
                            {candidateProfileDotNet.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <a
                          href="mailto:careers@aptech.co.in"
                          className={styles.link}
                        >
                          <div className={styles.buttonDiv}>
                            <p className="secondary-btn">
                              Apply for this position
                            </p>
                          </div>
                        </a>
                      </div>
                    </>
                  )} */}

                  {/* {title === "Network & Server Administrator" && (
                    <>
                      <div className="col-12 d-flex justify-content-start mb-3">
                        <div className="d-flex align-items-center">
                          <img
                            src={location}
                            alt="location"
                            width="40"
                            height="40"
                            className="img-fluid"
                          />
                          <p className="para mb-3 mt-3 p-1">Mumbai </p>
                        </div>
                      </div>
                      <div className="row g-0">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Brief Job Description:
                          </p>
                          <ul className={styles.listMainDiv}>
                            {jodDescriptionNetwork.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Desired Candidate Profile:
                          </p>
                          <ul>
                            {candidateProfileNetwork.map((item, index) => (
                              <li key={index}>
                                <p className="para">{item}</p>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <a
                          href="mailto:careers@aptech.co.in"
                          className={styles.link}
                        >
                          <div className={styles.buttonDiv}>
                            <p className="secondary-btn">
                              Apply for this position
                            </p>
                          </div>
                        </a>
                      </div>
                    </>
                  )}
                  {title === "Placement Manager" && (
                    <>
                      <div className="col-12 d-flex justify-content-start mb-3">
                        <div className="d-flex align-items-center">
                          <img
                            src={location}
                            alt="location"
                            width="40"
                            height="40"
                            className="img-fluid"
                          />
                          <p className="para mb-3 mt-3 p-1">Noida </p>
                        </div>
                      </div>
                      <div className="row g-0">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Brief Job Description:
                          </p>
                          <ul className={styles.listMainDiv}>
                            {jodDescriptionPlacementManager.map(
                              (item, index) => (
                                <li key={index}>
                                  <p className="para">{item}</p>
                                </li>
                              )
                            )}
                          </ul>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                          <p className="heading3 text-capitalize">
                            Desired Candidate Profile:
                          </p>
                          <ul>
                            {candidateProfilePlacementManager.map(
                              (item, index) => (
                                <li key={index}>
                                  <p className="para">{item}</p>
                                </li>
                              )
                            )}
                          </ul>
                        </div>
                        <a
                          href="mailto:careers@aptech.co.in"
                          className={styles.link}
                        >
                          <div className={styles.buttonDiv}>
                            <p className="secondary-btn">
                              Apply for this position
                            </p>
                          </div>
                        </a>
                      </div>
                    </>
                  )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section mt-2">
      <p className="para">There are currently no active vacancies. Please check back later for updates on new opportunities at Aptech.</p>
      </div>
      </div>
     
    </div>

  );
};

export default CareerWithAptech;
